import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import StateStorage from 'lib/state-storage'
import {
  segmentSignInViewed,
  segmentTrackProductAddedToWishlist,
} from 'lib/segment'
import {
  SEGMENT_STORAGE_KEY_PROMPT_LOCATION,
  SEGMENT_STORAGE_KEY_PRODUCT,
} from 'lib/segment/const'
import Button from 'components/common/button'
import Icon from 'components/common/icon'
import ICON from 'components/common/icon/const'
import authDuck from 'components/auth/duck'
import {
  addToWishlist,
  checkWishlistProductMultipleSizes,
  deleteFromWishlist,
} from './utils'

const WishlistCTA = ({
  isOnWishlist,
  isDeleteWishlistProductTimeOut,
  product,
  refType,
  setIsSnackBarOpen,
  user,
  updateShowLogin,
  refId,
}) => {
  const [isWishlisted, setIsWishlisted] = useState(isOnWishlist)
  const { id_product: productId } = product

  useEffect(() => {
    setIsWishlisted(isOnWishlist)

    if (isDeleteWishlistProductTimeOut) {
      deleteFromWishlist(productId, setIsWishlisted)
    }
  }, [isDeleteWishlistProductTimeOut, isOnWishlist, productId])

  useEffect(() => {
    const tempWishlist = StateStorage.getLocalState('TemporaryWishlist')

    if (tempWishlist?.id_product === productId) {
      addToWishlist(tempWishlist.id_product, setIsWishlisted)
      StateStorage.removeLocalState('TemporaryWishlist')
    }
  }, [productId])

  const showSignUp = () => {
    const promptLocation = 'wishlist_product'
    segmentSignInViewed(promptLocation)
    sessionStorage.setItem(SEGMENT_STORAGE_KEY_PROMPT_LOCATION, promptLocation)
    StateStorage.saveLocalState('TemporaryWishlist', product, false)
    updateShowLogin(true)
  }

  const getPreviousPageRefType = () => {
    const sessionObject = JSON.parse(
      sessionStorage.getItem(SEGMENT_STORAGE_KEY_PRODUCT.stack),
    )
    const lastObjKeyIndex = Object.keys(sessionObject).length - 1
    const lastSessionObjectIndex = Object.keys(sessionObject)[lastObjKeyIndex]
    const lastSessionObject = sessionObject[lastSessionObjectIndex]

    return lastSessionObject
  }

  const updateWishlist = async () => {
    if (user) {
      if (isWishlisted) {
        checkWishlistProductMultipleSizes(
          productId,
          user,
          setIsSnackBarOpen,
          setIsWishlisted,
        )
      } else {
        addToWishlist(productId, setIsWishlisted)

        const referrerRefType = refType ?? getPreviousPageRefType()?.ref_type
        segmentTrackProductAddedToWishlist(product, referrerRefType, refId)
      }
    } else {
      showSignUp()
    }
  }

  return (
    <Button className="pdp__wishlist-cta" onClick={updateWishlist}>
      <Icon
        alt="pdp wishlist icon"
        src={isWishlisted ? ICON.productWishlistFilled : ICON.productWishlist}
      />
    </Button>
  )
}

WishlistCTA.defaultProps = {
  isOnWishlist: false,
  user: null,
  refId: '',
}

WishlistCTA.propTypes = {
  isOnWishlist: PropTypes.bool,
  isDeleteWishlistProductTimeOut: PropTypes.bool.isRequired,
  product: PropTypes.shape({
    id_product: PropTypes.number,
  }).isRequired,
  refType: PropTypes.string.isRequired,
  refId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  setIsSnackBarOpen: PropTypes.func.isRequired,
  user: PropTypes.shape({ id_customer: PropTypes.number }),
  updateShowLogin: PropTypes.func.isRequired,
}

export default connect(
  (state) => ({
    user: state.auth.user,
  }),
  (dispatch) =>
    bindActionCreators(
      {
        updateShowLogin: authDuck.creators.updateShowLogin,
      },
      dispatch,
    ),
)(WishlistCTA)
